import { Editor } from 'slate'

import type { SlateMark } from './types'

export function isMarkActive(editor: Editor, format: SlateMark): boolean {
  const marks = Editor.marks(editor)
  return marks?.[format] === true
}

export function toggleMark(editor: Editor, format: SlateMark): void {
  const active = isMarkActive(editor, format)
  if (active) {
    Editor.removeMark(editor, format)
  } else {
    Editor.addMark(editor, format, true)
  }
}
